import TagManager from 'react-gtm-module'

import { CampaignPlatformTypeEnum, CampaignTypeEnum } from 'src/Types/campaigns'
import { ID } from 'src/Types/common'

import { EventTypeEnum } from '../tagManagerEnums'

export const selectCampaignGoalEvent = ({
  userId,
  campaignId,
  campaignType,
}: {
  userId?: ID | null
  campaignId: number
  campaignType: CampaignTypeEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,

      event_params: {
        event_name: 'select_campaign_goal',
        campaign_type: campaignType,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_id: campaignId,
        userID: userId,
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}

export const goalGetMoreVideoViewsEvent = ({
  userId,
  campaignId,
  campaignType,
}: {
  userId?: ID | null
  campaignId: number
  campaignType: CampaignTypeEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,

      event_params: {
        event_name: 'goal_get_more_video_views',
        campaign_type: campaignType,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_id: campaignId,
        userID: userId,
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}

export const goalGetMoreVideosEvent = ({
  userId,
  campaignId,
  campaignType,
}: {
  userId?: ID | null
  campaignId: number
  campaignType: CampaignTypeEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,

      event_params: {
        event_name: 'goal_get_more_videos',
        campaign_type: campaignType,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_id: campaignId,
        userID: userId,
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}

export const popupGoalSelectedEvent = ({
  userId,
  campaignId,
  campaignType,
}: {
  userId?: ID | null
  campaignId: number
  campaignType: CampaignTypeEnum
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,

      event_params: {
        event_name: 'popup_goal_selected',
        campaign_type: campaignType,
        campaign_platform: CampaignPlatformTypeEnum.TIKTOK,
        campaign_id: campaignId,
        userID: userId,
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}
